import { Size, shipmentPreferenceChoices, t, type ShipmentPreferenceRow } from '@bms2/shared';
import { Select } from '../../components/controls';
import { SHIPMENT_PREFERENCES_PATH, useRows } from './api';

/**
 * 🔒 How a document's goods travel (piece 22; T115, decision 0682): one
 * Select over the Settings › Documents list, drawn on the Quote's, the Sales
 * Order's, the Invoice's, the Purchase Order's and the Work Order's forms. The
 * list offers the active rows, and the row a stored document already names even
 * where it has since been switched off, so a reopened document keeps its choice.
 */
export function ShipmentPreferencePicker({ value, onChange, apiBaseUrl = '', name }: { value: string; onChange: (next: string) => void; apiBaseUrl?: string; name: string }) {
  const rows = useRows<ShipmentPreferenceRow>(SHIPMENT_PREFERENCES_PATH, apiBaseUrl);
  const options = shipmentPreferenceChoices(rows.state.kind === 'ready' ? rows.state.data : [], value || null);
  return (
    <Select
      size={Size.Medium}
      label={t('document.edit.shipmentPreference')}
      value={value}
      onChange={onChange}
      placeholder={t('document.edit.shipmentPreferenceNone')}
      options={options}
      dataAttribute={{ 'data-shipment-preference': name }}
    />
  );
}
